module.exports = __webpack_public_path__ + "img/CRT_Spear-004.26a45fda.png";